import update from 'immutability-helper';

import { SET, ADDED, UPDATED, DELETED } from './actions';
import * as questionsActions from "../questions/actions";

const initialState = {};

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.answers;

    case ADDED:
      return {
        ...state,
        [action.answer.id]: action.answer
      };

    case UPDATED:
      return update(state, {
        [action.answer.id]: {
          $set: action.answer
        }
      });
    case DELETED:
      return update(state, {
        $unset: [action.answer.id]
      });

    case questionsActions.TYPE_UPDATED:
      const ids = [];

      _.each(state, answer => {
        if (answer.question.id === action.expiredId)
          ids.push(answer.id);
      });

      return update(state, {
        $unset: ids
      });

    default:
      return state;
  }
};